// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import Button from '../Button';
import PopupContent from '../PopupContent';
import PopupFooter from '../PopupFooter';
import { FullLoader } from '../Loader';

import * as userAction from '../../actions/users';
import * as closeableAction from '../../actions/closeable';
import * as selectors from '../../reducers';
import styles from './createUsersConfirm.css';
import { Cancel, CreateButton, Loading } from '../CommonTexts';

type CreateUsersConfirmPropTypes = {
  errors: number,
  isUploading: boolean,
  uploadUsers: Function,
  cancelUpload: Function,
  uploadingUsers: Array<Object>,
};

const CreateUsersConfirm = ({
  errors = 0,
  uploadUsers,
  cancelUpload,
  isUploading = false,
  uploadingUsers = [],
}: CreateUsersConfirmPropTypes) => (

  <Fragment>
    <PopupContent size="large">
      <div className={styles.title}>
        { 'Se crearán: ' }
        <strong>
          { i18n.t('common.user', { count: uploadUsers.length }) }
        </strong>
        { 'y se encontaron ' }
      </div>
      <div className={styles.title}>
        { `${errors} filas con errores...` }
      </div>
      {
        isUploading ? <FullLoader tint="main" title={Loading(i18n.t('common.user', { count: 2 }))} /> : (
          <div className={styles.tableContainer}>
            {
            typeof uploadingUsers !== 'undefined' && uploadingUsers.length ? (
              <table className={styles.table}>
                <tbody>
                  {
                    uploadingUsers.map(user => (
                      <tr
                        key={user.id}
                        className={`${user.complete ? '' : styles.incomplete}`}
                      >
                        <th>
                          { `${user.nombre} ${user.apellido}` }
                        </th>
                        <td>
                          { user.tipo }
                        </td>
                        <td>
                          { user.telefono }
                        </td>
                        <td>
                          { user.email }
                        </td>
                        <td>
                          { user.codigo }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>) : null
            }
          </div>)
      }
    </PopupContent>
    <PopupFooter size="large">
      <Button
        title={Cancel()}
        tint="gray"
        isOutlined
        clearMargins
        onClick={() => cancelUpload()}
      />
      <Button
        size="medium"
        title={CreateButton(i18n.t('common.user', { count: 2 }))}
        className={styles.approve}
        onClick={() => uploadUsers(uploadingUsers)}
      />
    </PopupFooter>
  </Fragment>
);

export default connect(
  state => ({
    errors: selectors.getUploadingErrors(state),
    isUploading: selectors.isUploadingUsers(state),
    uploadingUsers: selectors.getUploadingUsers(state),
  }),
  dispatch => ({
    uploadUsers(users) {
      dispatch(userAction.uploadUsersStart(users));
    },
    cancelUpload() {
      dispatch(closeableAction.close('uploadUsers'));
      dispatch(userAction.clearUploadingUsers());
    },
  }),
)(CreateUsersConfirm);



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUsersConfirm/index.jsx